import React, { Component } from 'react';
import TableC from '../../../basicElement/TableC';
import moment from 'moment';


class SupervisionInfo extends Component {

    getColumns = () => {
        const columns = [
            {
                title: '序号',
                dataIndex: 'sortNum',
                key: 'sortNum',
                width: 60,
            },
            {
                title: '检查日期',
                dataIndex: 'inspectDate',
                key: 'inspectDate',
                width: 100,
                render: text => text ? moment(text).format('YYYY-MM-DD'): ''
            },
            {
                title: '检查类别',
                dataIndex: 'checkModeStr',
                key: 'checkModeStr',
                width: 100,
            },
            {
                title: '监督检查结果',
                dataIndex: 'checkResult',
                key: 'checkResult',
                width: 140,
            },
            {
                title: '处理情况',
                dataIndex: 'illegalActPunish',
                key: 'illegalActPunish',
                width: 100,
            },
        ];
        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.props;
        const dataSource = [];
        (data || []).map((el, index) => {
            dataSource.push({
                ...el,
                sortNum: (pagination.current - 1) * 10 + index + 1,
            });
        });
        return dataSource
    }

    render() {
        const { pagination, handleTableChange } = this.props;

        return (
            <div>
                <TableC
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    rowKey="id"
                    onChange={handleTableChange}
                    pagination={pagination}
                />
            </div>
        );
    }
}


export default SupervisionInfo


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/components/SupervisionInfo.js